const TagIcon = ({ color = "currentColor" }: { color?: string }) => {
  return (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <path
        d="M7.28942 3.38172C7.78767 2.88346 8.47586 2.62488 9.17335 2.67385L11.5335 2.83955C12.712 2.92229 13.6425 3.85282 13.7252 5.03129L13.8909 7.39144C13.9399 8.08893 13.6813 8.77712 13.1831 9.27537L9.27439 13.1841C8.33175 14.1267 6.81368 14.1369 5.88369 13.207L3.35784 10.6811C2.42784 9.75111 2.43809 8.23304 3.38073 7.2904L7.28942 3.38172Z"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TagIcon;
